module.exports = __webpack_public_path__ + "img/المدينة المنورة.d942bd80.svg";